import React, { useContext, useEffect, useState } from "react";
import { Form, FormCheck } from "react-bootstrap";
import './styles.css'
import Context from "../../../../context/Context";

export const WagonTableRadio = ({confirmedWagon, reset, status }) => {

  const {
    furnace, getFurnace, 
    setSelectedFurnace,
    selectedFurnace,
    getPartsByFurnace,
    getConfirmedWagon,
  } = useContext(Context);

  useEffect(() => {
    getFurnace()
  }, []);

  return (
    <>
      <Form className="">
        {['radio'].map((type) => (
          <div key={`reverse-${type}`} className="mb-3 d-flex justify-content-center py-2 wagon-radio">
            {furnace.map((item, index) => (
              <FormCheck
                className="wagon-formcheck px-4"
                defaultValue={selectedFurnace}
                onClick={() => {
                  // getConfirmedWagon(status, selectedFurnace)
                  reset()
                  getPartsByFurnace(item.forno_Name)
                  // getConfirmedWagon(item.forno_Name)
                  setSelectedFurnace(item.forno_Name)
                }}
                key={index}
                label={item.forno_Name}
                name="group1"
                type={type}
              />
            ))}
          </div>
        ))}
      </Form>
    </>
  );
};
